
let portal: HTMLElement | null = null;
let hideTimer: number | null = null;

function ensurePortal(): HTMLElement {
  if (portal) return portal;
  portal = document.createElement("div");
  portal.className = "tip-portal";
  portal.setAttribute("role", "tooltip");
  portal.hidden = true;
  document.body.appendChild(portal);
  return portal;
}

function place(target: HTMLElement, text: string): void {
  const p = ensurePortal();
  p.textContent = text;
  p.hidden = false;

  p.style.left = "0px";
  p.style.top = "0px";
  const r = target.getBoundingClientRect();
  const tipRect = p.getBoundingClientRect();
  const margin = 8;
  const viewportW = window.innerWidth;

  let left = r.left + r.width / 2 - tipRect.width / 2;
  if (left < 4) left = 4;
  if (left + tipRect.width > viewportW - 4) left = viewportW - tipRect.width - 4;

  let top = r.top - tipRect.height - margin;
  let arrowDown = true;
  if (top < 4) {
    top = r.bottom + margin;
    arrowDown = false;
  }
  p.style.left = `${Math.round(left)}px`;
  p.style.top = `${Math.round(top)}px`;
  p.dataset.arrow = arrowDown ? "down" : "up";
}

function hide(): void {
  if (!portal) return;
  portal.hidden = true;
  portal.textContent = "";
}

function onEnter(ev: Event): void {
  const target = (ev.target as HTMLElement | null)?.closest?.<HTMLElement>("[data-tip]");
  if (!target) return;
  const text = target.dataset.tip;
  if (!text) return;
  if (hideTimer !== null) { window.clearTimeout(hideTimer); hideTimer = null; }
  place(target, text);
}

function onLeave(ev: Event): void {
  const target = (ev.target as HTMLElement | null)?.closest?.<HTMLElement>("[data-tip]");
  if (!target) return;

  hideTimer = window.setTimeout(hide, 60);
}

export function initTooltipPortal(): void {
  if (portal !== null) return;
  ensurePortal();
  document.addEventListener("mouseover", onEnter, true);
  document.addEventListener("mouseout", onLeave, true);
  document.addEventListener("focusin", onEnter, true);
  document.addEventListener("focusout", onLeave, true);

  window.addEventListener("scroll", hide, true);
  window.addEventListener("resize", hide);
}
